import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  ProjectItem,
  TitleSection,
  ProjectName,
  Div,
  DivLeftSection,
  Title,
  Text,
  MiddleDiv,
  JoinButtonSection,
  AssignGroup1
} from '../styles';
import Avatar from '../../../../component/avatar';
import ProjectIconAvatar from '../../../../component/projectIconAvatar';
import { AVATAR_BORDER, ICON_COLORS, PROJECT_ICON_TYPE } from '../../../../global/constants';
import { isEmpty } from '../../../../helpers/common';
import { OtherProjectListItemProps } from '../../../../interfaces/ProjectInterface';

const OtherProjectListItemComponent: React.FC<OtherProjectListItemProps> = ({ item, isMobile, renderJoinButton }) => {
  return (
    <ProjectItem>
      <TitleSection>
        <ProjectIconAvatar
          size={isMobile ? 36 : 26}
          type={item?.icon?.type ?? PROJECT_ICON_TYPE.DEFAULT}
          reference={item?.icon?.reference || ''}
          backgroundColor={ICON_COLORS[item?.icon?.color || 1]}
          projectName={item?.name}
          iconSize={isMobile ? 20 : 16}
          borderRadius={isMobile ? '8px' : '6px'}
        />
        <ProjectName className='admin-project-name'>
          <Div>
            <DivLeftSection className='admin-project'>
              <Title>{item?.name}</Title>
              {!isEmpty(item?.customer?.companyName) && <Text>for {item?.customer?.companyName}</Text>}
            </DivLeftSection>
            {isMobile && renderJoinButton && renderJoinButton(item)}
          </Div>
        </ProjectName>
      </TitleSection>
      <MiddleDiv className='admin-project'>
        <JoinButtonSection>
          <AssignGroup1 className='admin-assign'>
            <ul>
              {item?.users?.map((user, index) => {
                if (index > 3) return <React.Fragment key={user?.id}></React.Fragment>;
                return (
                  <li key={user?.id}>
                    <Avatar
                      imgSrc={user?.profile_photo || ''}
                      name={user?.name ? user.name : 'U N'}
                      size={20}
                      borderVariant={AVATAR_BORDER.THIN}
                      className='avatar'
                    />
                  </li>
                );
              })}
              {item?.users?.length > 4 && <li className='plus-icon'>+{item?.users?.length - 4}</li>}
            </ul>
          </AssignGroup1>
          {!isMobile && renderJoinButton && renderJoinButton(item)}
        </JoinButtonSection>
      </MiddleDiv>
    </ProjectItem>
  );
};

const OtherProjectListItem = observer(OtherProjectListItemComponent);

export default React.memo(OtherProjectListItem);
